import {changeLogo} from './utils';

$(function() {
  let filter = ''
  let offset = 0
  let limit = 9
  let isShowModalSearch = false

  $('.search-icon').on('click', openSearchModal)

  $('#searchModal').on('shown.bs.modal', function() {
    $('.search-modal__input').focus();
    let searchKeyword = $('.search-modal__input').val()
    if(searchKeyword){
      searchByKeyword(searchKeyword, offset)
    }
  })

  $('#searchModal').on('hidden.bs.modal', function() {
    clearSearchModal()
  })

  $('#overlayModal').on('hidden.bs.modal', function() {
    $('.overlay-modal .search__input').val('')
  })

  $('.menu-icon').on('click', openOverlayModal)

  $('.overlay-modal .search__input').on('change', (e) => {
    $('.search-modal__input').val(e.target.value)
  })

  $('.overlay-modal .search__icon').on('click', openSearchModal)

  $('.close-modal').on('click', function() {
    closeModal()
    $('#hamburger').css('display', 'none');
    if(window.matchMedia("(max-width: 1200px)").matches){
      $('#hamburger').css('display', 'block');
    }
  })

  $(document).on('keydown', function(event) {
    if (event.key == "Escape") {
      closeModal()
    }
  })

  const runNewSearch = () => {
    $('.search-modal__articles').empty()
    offset = 0
    filter = $('.search-modal__input').val()
    searchByKeyword(filter, offset);
  }

  $('.search-modal__input').on('keydown', function() {
    if (event.key === "Enter") {
      runNewSearch();
    }
  })

  $('.search-modal__search-icon').on('click', function() {
    runNewSearch();
  })

  $('.search-modal__close-icon').on('click', clearSearchModal)

  $('.search-modal__btn').on('click', function () {
    if ($(this).attr('id') === 'fl-search-loadmore') {
      // !Preserve redundunt search from fl search modal!
      return;
    }

    offset += limit;
    searchByKeyword(filter, offset)
  })

  function searchByKeyword(filter = '', offset) {
    let lang = currentEnvironment.language;
    const url = `/${lang}/search?filter=${filter}&offset=${offset}&limit=${limit}`
    $.getJSON(url, (response) => renderSearchByKeywords(response.data, response.count))
  }

  function renderSearchByKeywords(articles, count) {
    $.each(articles, function(index, item) {
      const icon = getIcon(item.pageType)

      $('.search-modal__articles').append(
        `<a class="regular-card search-modal__card" href="${item.url}">
          <div class="regular-card__header">
            <img class="regular-card__img" src="${item.image['348x164']}" alt="article">
            <img class="regular-card__icon" src="/assets/img/icons/${icon}" alt="article">
          </div>
          <div class="regular-card__content">
            <div class="regular-card__title">
              ${item.headline}
            </div>
            <div class="regular-card__tag">
              ${item.tag}
            </div>
            <div class="regular-card__date">
              ${item.date}
            </div>
          </div>
        </a>`
      )
    })

   $('.search-modal__result span').html(count || 0)

    // show loadmore only when articles.count > limit

    $('.search-modal__btn').css({
      display: $('.search-modal__articles .regular-card').length < count ? 'block' : 'none'
    })
  }

  function openSearchModal() {
    $('#overlayModal').modal('hide')
    $('.close-modal').attr({'data-bs-target': '#searchModal'})
    $('#search').closest('.nav-item').addClass('active')

    if(!isShowModalSearch) {
      $('#searchModal').modal('show')
      $('body').css({overflow: 'hidden'})
      //changeHeaderStyleOnOpenModal()
    } else {
      $('#searchModal').modal('hide')
      //changeHeaderStyleOnCloseModal()
      changeLogo()
      $('body').css({overflow: 'auto'})
    }
    isShowModalSearch = !isShowModalSearch
  }

  function openOverlayModal() {
    $('.close-modal').attr({'data-bs-target': '#overlayModal'})

    $('#overlayModal').modal('show')
    changeHeaderStyleOnOpenModal()

    isShowModalSearch = false
  }

  function closeModal() {
    const currentTarget = $('.close-modal').attr('data-bs-target')

    if (currentTarget === '#overlayModal') {
      $('#overlayModal').modal('hide')
    } else {
      $('#searchModal').modal('hide')
      isShowModalSearch = false
    }

    if (!$('#searchModal:visible').length || window.matchMedia("(max-width: 1200px)").matches) {
      changeHeaderStyleOnCloseModal()
    }
    changeLogo()
    $('#search').closest('.nav-item').removeClass('active')
    $('body').css({overflow: 'auto'})
  }
});

function changeHeaderStyleOnCloseModal() {
  $('.menu-icon').show()
  $('.close-modal').hide()
  $('#logo-small').hide()
  $('#logo-corner').show()
}

export function changeHeaderStyleOnOpenModal() {
  $('.menu-icon').hide()
  $('.close-modal').show()
  $('#logo-small').show()
  $('#logo-corner').hide()
}

function getIcon(type) {
  const icons = {
    video: 'icon_dark_video@3x.svg',
    article: 'icon_dark_article@3x.svg',
    podcast: 'icon_dark_podcast@3x.svg'
  }

  return icons[type] || 'icon_dark_article@3x.svg'
}

function clearSearchModal() {
  $('.search-modal__articles').html('');
  $('.search-modal__input').val('');
  $('.search-modal__result span').html(0)
  $('.search-modal__btn').css({display: 'none'})
}
